// 最頻材料の名称 + 余剰種類数サフィックス。出荷/搬入サマリの1チップ表示に使う共通ヘルパ。
// (CarryOutPage/CarryInPage で同型実装が重複していたため抽出: C-8)

export function mostFrequentMaterialLabel(materialIds: (number | null | undefined)[], nameOf: (materialId: number) => string): string {
  const counts = new Map<number, number>();
  materialIds.forEach((materialId) => {
    if (materialId != null) {
      counts.set(materialId, (counts.get(materialId) ?? 0) + 1);
    }
  });
  if (counts.size === 0) {
    return "";
  }
  let topId = -1;
  let topCount = 0;
  counts.forEach((count, id) => {
    if (count > topCount) {
      topCount = count;
      topId = id;
    }
  });
  const name = nameOf(topId);
  if (counts.size > 1) {
    return `${name} +${counts.size - 1}種`;
  }
  return name;
}
